import React, { useState } from 'react'
import {useLocation} from 'react-router-dom';
import Form_Settings from './Form Settings/Form_Settings'
import Communication_Settings from './Communication Settings/Communication_Settings'
import View_Settings from './View Settings/View_Settings'
import Subscription_Settings from './Subscription Settings/Subscription_Settings'

export default function OSPSettings() {

  const [active, setActive] = useState('Form Settings')
  const location = useLocation()
  const message = location.state?.message || "No message received";


  return (
    <div className='px-6'>
      <h1 className='font-semibold text-2xl text-gray-600'>OSP Settings </h1>

      {/* Nav Four Tabs */}

      <div className='my-7 flex gap-5'>
        <p class="relative inline-block">
          <span class={`relative z-10 cursor-pointer text-gray-600 text-md font-medium hover:text-red-600 ${active === 'Form Settings' ? 'text-red-600' : ''}`} onClick={() => setActive('Form Settings')}>Form Settings</span>
          {active === 'Form Settings' && <span class="absolute bottom-0 left-0 w-full h-1 bg-red-600 rounded-full"></span>}
        </p>
        <p class="relative inline-block">
          <span class={`relative z-10 cursor-pointer text-gray-600 text-md font-medium hover:text-red-600 ${active === 'Communication Settings' ? 'text-red-600' : ''}`} onClick={() => setActive('Communication Settings')}>Communication Settings</span>
          {active === 'Communication Settings' && <span class="absolute bottom-0 left-0 w-full h-1 bg-red-600 rounded-full"></span>}
        </p>
        <p class="relative inline-block">
          <span class={`relative z-10 cursor-pointer text-gray-600 text-md font-medium hover:text-red-600 ${active === 'View Settings' ? 'text-red-600' : ''}`} onClick={() => setActive('View Settings')}>View Settings</span>
          {active === 'View Settings' && <span class="absolute bottom-0 left-0 w-full h-1 bg-red-600 rounded-full"></span>}
        </p>
        <p class="relative inline-block">
          <span class={`relative z-10 cursor-pointer text-gray-600 text-md font-medium hover:text-red-600 ${active === 'Subscription Settings' ? 'text-red-600' : ''}`} onClick={() => setActive('Subscription Settings')}>Subscription Settings</span>
          {active === 'Subscription Settings' && <span class="absolute bottom-0 left-0 w-full h-1 bg-red-600 rounded-full"></span>}
        </p>
      </div>

      {active === 'Form Settings' && <Form_Settings />}
      {active === 'Communication Settings' && <Communication_Settings />}
      {active === 'View Settings' && <View_Settings message={message === 'OSP-settings'}/>}
      {active === 'Subscription Settings' && <Subscription_Settings />}
    </div>
  )
}
